import { setCookie } from 'cookies-next';

export async function tnpscolduser(data) {
    const response = await fetch(`https://admin.shankariasacademy.com/siaadminpanel/web/form/submit?formType=`+data.fields.formType, {
        method: 'POST',
        headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'},
        body: JSON.stringify(data)
      })
      if (await !response.ok) {
        const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
      const responseData=await response.json();
      setCookie('OtpToken', responseData.data[0].id,{secure: false,maxAge: 60 * 30,sameSite: "strict",path: "/"});
      return responseData;
}

export const tnpscmailcnfm = async (data) => {
    const value = data;
    console.log(value);
   
    
     const token = "NDp4UVRybXJ6Zktvd3c=";
     try {
       const response = await fetch("https://www.shankariasacademy.com/blog/wp-json/api/v2/oldstdtnpscgrIIprelimsm", {
         method: "POST",
         headers: {
           "Content-Type": "application/json",
           "Accept": "application/json",
           
          'Authorization': `Bearer ${token}`,
         },
         mode: "cors",
         cache: "no-cache",
         body: JSON.stringify(
           value
         ),
       });
   
       const data = await response.json();
     
        return data;
      
       //console.log("Response:", data);
      
     } catch (error) {
       console.error("Error sending data:", error);
     }
   };